import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Add } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { PageHeader } from 'components/page-header';
import routes from '~/routes';
import ExpenseScenariosContent from './expense-scenarios-content';

/**
 * Entry page for the Expense Scenarios list.
 * @return {JSX.Element} The list page
 */
const ExpenseScenariosPage: FC = () => {
  const history = useHistory();

  return (
    <>
      <PageHeader
        breadcrumbs={[]}
        title="Expense Scenario"
        actions={
          <Button
            renderIcon={Add}
            kind="primary"
            onClick={() => history.push(routes.newExpenseScenarioPath)}
          >
            Create Expense Scenario
          </Button>
        }
      />
      <ExpenseScenariosContent />
    </>
  );
};

export { ExpenseScenariosPage };
